import { call, put, takeLatest } from 'redux-saga/effects';
import {
	fetchGuestScripPriceV2,
	setGuestScripPriceV2,
} from '../reducers/guestLoginV2';
import {
	setActionLoaderFalse,
	setActionLoaderTrue,
} from '../reducers/actionLoader';

import { getGuestScripDetailV2 } from '../../apis/guestLoginV2';
import { noop } from 'lodash-es';
import { setError } from '../reducers/error';
import { setLoader } from '../reducers/loader';

function* handleFetchGuestScripPrice({ payload }) {
	const {
		Api,
		screen = '',
		scripToken = '',
		sagaCallBack = noop,
		marketSegmentId = '',
		isIndex = 0,
	} = payload;

	try {
		yield put(setActionLoaderTrue(fetchGuestScripPriceV2));
		yield put(setError({ screen, isFetchFailed: false, message: '' }));
		const response = yield call(
			getGuestScripDetailV2,
			Api,
			scripToken,
			marketSegmentId,
			isIndex,
		);
		yield put(setGuestScripPriceV2(response?.data));
		yield put(setLoader({ screen, isFetchGuestPrice: false }));
		yield call(sagaCallBack, response?.data);
	} catch (error) {
		console.log('handleFetchGuestScripPrice', error);
		yield put(
			setError({ isFetchFailed: true, screen, message: error.message }),
		);
	} finally {
		yield put(setActionLoaderFalse(fetchGuestScripPriceV2));
	}
}

export default function* guestLoginSaga() {
	yield takeLatest(
		fetchGuestScripPriceV2.toString(),
		handleFetchGuestScripPrice,
	);
}
